/**
 * Halal directory feature flag — isolated because it touches `import.meta.env`.
 *
 * Mirrors `features/prayer-times/featureFlag.ts`. Kept out of any file the Jest
 * test graph imports, since `import.meta` is a syntax error under CommonJS.
 */

/**
 * Whether the halal directory is exposed in the UI (nav entries, discoverability).
 *
 * Default OFF, and it must stay OFF until the backend `LISTINGS_ENABLED` flag is on —
 * otherwise a nav link would lead users to a page whose API returns 404. Flip both
 * together at go-live.
 *
 * @returns `true` only when `VITE_FEATURE_HALAL_DIRECTORY` is the string `'true'`.
 */
export function isHalalDirectoryEnabled(): boolean {
  return (
    (import.meta.env.VITE_FEATURE_HALAL_DIRECTORY ?? 'false')
      .toString()
      .toLowerCase() === 'true'
  );
}

// Deploy marker: rebuild to bake VITE_FEATURE flags + fix prerender (2026-07-18).
